module.exports = __webpack_public_path__ + "static/img/20210315162551.384181f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/inspectionImg/20210315/20210315162551.jpg
// module id = Q8+o
// module chunks = 11